import { FilterFormats } from '../../../components/raw-sql/types'

export const DEFAULT_RAW_SQL_LIST_LAYOUT = `
    <div class="hamburger-container">
      <div class="col-sm-12 mb5 d-flex flex-wrap justify-content-between align-items-end">
        <list-header-menu />
        <!--Page Limiter-->
        <limitation class="el-select mb-2 ms-md-auto order-3"/>
      </div>
    </div>
    <!--    Pagination    -->
    <pagination/>
    <!--    List View    -->
    <list-view-container/>
    <!--    Paginator    -->
    <pagination/>
  `

export const DEFAULT_RAW_SQL_BIND_LAYOUT = `
    <div class="gap-1 border align-baseline" style="min-height: 75px;border-radius: 8px;">
      <div
        class="raw-sql-bind-header d-flex align-items-center px-3 py-2"
        @click="collapseBind(bindName)"
      >
        <span class="flex-grow-1">{{ bindLabel }}</span>
        <span class="material-icons">unfold_less</span>
      </div>
      <div class="flex-grow-1 p-3">
        <template v-if="isDropdown">
          <multi-select v-if="isMultiselect" v-bind="bindProps" v-on="$listeners"/>
          <single-select v-else v-bind="bindProps" v-on="$listeners"/>
        </template>
        <checkbox-list v-else-if="isCheckboxList" v-bind="bindProps" :max-height="250"/>
        <date-controller v-else-if="isDateType" v-bind="bindProps" v-on="$listeners"/>
        <input v-else class="el-input el-input__inner" v-model="bindValue"/>
      </div>
    </div>`

export const INTERVAL_CAPABLE_FILTER_TYPES = [FilterFormats.DATE, FilterFormats.DATETIME, FilterFormats.TIME]

export const ENUMERATED_FILTER_TYPES = [FilterFormats.DROPDOWN, FilterFormats.CHECKBOX, FilterFormats.RAW_SQL]
export const DATE_FIELD_TYPES = [
  'date',
  'time',
  'datetime-local',
  'date-interval',
  'time-interval',
  'datetime-interval',
]
export const DEFAULT_CONDITION_VALUES = {
  booleanValue: null,
  dateValue: null,
  dateIntervalValue: null,
  numberValue: undefined,
  numberIntervalValue: [],
  dropdownValue: undefined,
  textValue: '',
}

export const EMPTY_CONDITION_BUILDER = {
  operation: '',
  field: '',
  values: { ...DEFAULT_CONDITION_VALUES },
  label: '',
  isDynamic: true,
}

export const CORE_RE = /:CORE.([\w\.]+)|:DOTO.([\w\.]+)/ // @regex match CORE param relations
